// InstitutionsTable.jsx
import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Icon,
  Loader,
  Message,
  Confirm,
  Header,
  Image,
} from "semantic-ui-react";
import { InstitutionApi } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { image } from "../../../../assets"; // tu placeholder de avatar
import { useTranslation } from "react-i18next";

const institutionController = new InstitutionApi();

export function InstitutionsTable({ active, reload, onReload, onEdit }) {
  const { accessToken, user } = useAuth();
  const { t } = useTranslation(["partners", "common"]);
  const [data, setData] = useState(null);
  const [error, setError] = useState();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    setData(null);
    institutionController
      .getInstitutions(accessToken, user.user._id, active)
      .then((r) => setData(r.institutions || []))
      .catch((e) => {
        setError(e.message);
        setData([]);
      });
  }, [accessToken, user, active, reload]);

  if (data === null) return <Loader active inline="centered" />;
  if (error) return <Message error content={error} />;
  if (!data.length)
    return (
      <Message info content={t("partners:institutionTable.noInstitutions")} />
    );

  return (
    <>
      <Table celled compact selectable striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              {t("partners:institutionTable.colInstitution")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("partners:institutionTable.colPlan")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("partners:institutionTable.colLicense")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("partners:institutionTable.colExpires")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("partners:institutionTable.colStudents")}
            </Table.HeaderCell>
            <Table.HeaderCell>
              {t("partners:institutionTable.colTeachers")}
            </Table.HeaderCell>
            <Table.HeaderCell textAlign="center">
              {t("partners:institutionTable.actionsHeader")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {data.map((inst) => (
            <Table.Row
              key={inst._id}
              positive={inst.active}
              negative={!inst.active}
            >
              {/* Columna Institución con avatar */}
              <Table.Cell>
                <Header as="h4" image>
                  <Image
                    src={inst.avatar || image.noAvatar}
                    rounded
                    size="mini"
                  />
                  <Header.Content>{inst.institutionnam}</Header.Content>
                </Header>
              </Table.Cell>

              {/* Columna Plan con su icono */}
              <Table.Cell>
                <Header as="h4" image>
                  <Image
                    src={inst.planEduca?.miniature || image.noAvatar}
                    rounded
                    size="mini"
                  />
                  <Header.Content>{inst.planEduca?.title}</Header.Content>
                </Header>
              </Table.Cell>

              <Table.Cell>{inst.planEduca?.account}</Table.Cell>
              <Table.Cell>{inst.expired_at?.split("T")[0] || "N/A"}</Table.Cell>
              <Table.Cell>{inst.studentsnum}</Table.Cell>
              <Table.Cell>{inst.teachersnum}</Table.Cell>
              <Table.Cell textAlign="center">
                <Button icon as="a" href={inst.website} target="_blank">
                  <Icon name="eye" />
                </Button>
                <Button icon primary onClick={() => onEdit(inst)}>
                  <Icon name="pencil" />
                </Button>
                <Button
                  icon
                  color={inst.active ? "orange" : "teal"}
                  onClick={() => {
                    setCurrent(inst);
                    setConfirmOpen(true);
                  }}
                >
                  <Icon name={inst.active ? "ban" : "check"} />
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>

      <Confirm
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={() => {
          institutionController
            .toggleInstitutionActivation(
              accessToken,
              current._id,
              !current.active,
            )
            .then(() => {
              onReload();
              setConfirmOpen(false);
            })
            .catch(() => setConfirmOpen(false));
        }}
        content={`${t("partners:institutionTable.confirmToggle")} ${current?.active ? t("partners:institutionTable.confirmDeactivate") : t("partners:institutionTable.confirmActivate")} "${current?.institutionnam}"?`}
      />
    </>
  );
}
